// extracted by mini-css-extract-plugin
export default {"input-wrapper":"NumericInput_input-wrapper__JiHiH","input-wrapper__input":"NumericInput_input-wrapper__input__3qwlQ"};